import { render, staticRenderFns } from "./MinisiteSidebar.vue?vue&type=template&id=824b5f44&scoped=true&"
import script from "./MinisiteSidebar.vue?vue&type=script&lang=js&"
export * from "./MinisiteSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteSidebar.vue?vue&type=style&index=0&id=824b5f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824b5f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('824b5f44')) {
      api.createRecord('824b5f44', component.options)
    } else {
      api.reload('824b5f44', component.options)
    }
    module.hot.accept("./MinisiteSidebar.vue?vue&type=template&id=824b5f44&scoped=true&", function () {
      api.rerender('824b5f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisiteSidebar.vue"
export default component.exports